module.exports = __webpack_public_path__ + "assets/img/znckydz.d0f0fc57.png";